/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./Home.css"; // Import the CSS file for styles
import student from "../assets/bg-img/icons8-student-male-94.png";
import updates from "../assets/bg-img/icons8-bell-94.png";
import attendance from "../assets/bg-img/icons8-date-94.png";
import exam from "../assets/bg-img/icons8-test-passed-94.png";
import def from "../assets/bg-img/default.png";
import SyncLoader from "react-spinners/SyncLoader";
import api from "../utils/Api";

const Home = () => {
  const navigate = useNavigate();
  const [studentName] = useState(localStorage.getItem("studentName"));
  const [loading, setLoading] = useState(false); // Added loading state

  const { id } = useParams();
  // Function to determine greeting based on current time
  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return "Good Morning!";
    } else if (currentHour < 17) {
      return "Good Afternoon!";
    } else {
      return "Good Evening!";
    }
  };

  const getDisplayName = (name) => {
    return name.length > 10 ? name.substring(0, 10) + "..." : name;
  };

  const fetchStudentDetails = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    const enrollId = localStorage.getItem("enrollId");
    const fd = new FormData();
    fd.append("programType", "getStudentDetails");
    fd.append("enrollId", enrollId);
    fd.append("authToken", token);
  
    try {
      const response = await api.post("parentApp/studentCurl2", fd);
      // console.log("Student API Response:", response);
  
      if (response.data?.success && Array.isArray(response.data.data)) {
        const student = response.data.data[0];
  
        // ✅ Save class_id and section_id to localStorage
        if (student?.class_id && student?.section_id) {
          localStorage.setItem("classId", student.class_id);
          localStorage.setItem("sectionId", student.section_id);
        }
  
       
      } else {
        console.error("Invalid API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchStudentDetails();
  }, []);


  

  return (
    <div>
      {/* Show Loader when loading */}
      {loading ? (
        <div className="text-center my-4">
          <SyncLoader
            color="orange"
            loading={loading}
            size={10}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          />
        </div>
      ) : (
        <div className="page-content-wrapper py-3">
          {/* Element Heading */}
          <div className="container">
            <h5 className="" style={{ marginTop: "40px" }}>
              {getGreeting()}
            </h5>
          </div>

          <div className="container">
            <div className="row" style={{ marginLeft: "2px", marginRight: "2px" }}>
              <div className="col-12" style={{ padding: "5px" }}>
                <Link to="/students" className="card card-hover">
                  <div className="card-body">
                    <h2
                      className="mt-2 d-flex justify-content-between align-items-center"
                      style={{ fontSize: "15px" }}
                    >
                      <span>
                        <img
                          src={def}
                          alt={student.studentName}
                          className="rounded-circle"
                          style={{
                            width: "30px",
                            height: "30px",
                            marginRight: "15px",
                          }}
                        />
                        Select Child
                      </span>
                      <i className="bi bi-arrow-right"></i>
                    </h2>
                  </div>
                </Link>
              </div>

              <div className="col-6" style={{ padding: "5px" }}>
                <Link to="/student-details" className="card card-hover">
                  <div className="card-body text-center">
                    <img className="mb-2" src={student} alt="Student" width={"50px"} />
                    <h2 className="" style={{ fontSize: "15px" }}>{getDisplayName(studentName)}</h2>
                  </div>
                </Link>
              </div>

              <div className="col-6" style={{ padding: "5px" }}>
                <Link to="/notifications" className="card card-hover">
                  <div className="card-body text-center">
                    <img className="mb-2" src={updates} alt="Updates" width={"50px"} />
                    <h2 className="" style={{ fontSize: "15px" }}>Updates</h2>
                  </div>
                </Link>
              </div>

              <div className="col-6" style={{ padding: "5px" }}>
                <Link to="/attendance" className="card card-hover">
                  <div className="card-body text-center">
                    <img className="mb-2" src={attendance} alt="Attendance" width={"50px"} />
                    <h2 className="" style={{ fontSize: "15px" }}>Attendance</h2>
                  </div>
                </Link>
              </div>

              <div className="col-6" style={{ padding: "5px" }}>
                <Link to="/student-result" className="card card-hover">
                  <div className="card-body text-center">
                    <img className="mb-2" src={exam} alt="Exam" width={"50px"} />
                    <h2 className="" style={{ fontSize: "15px" }}>Exam</h2>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
